import React from "react";
import { CircularProgress } from "@material-ui/core";
import { fontSize } from "@material-ui/system";

function ActionButton(props) {
  return (
    <div
      className="contact-button"
      style={{ ...props.styles }}
      onClick={() => {
        if (typeof props.onClick !== "undefined") {
          props.onClick();
        }
      }}
    >
      <p style={{ fontSize: "16px" }}>{props.label}</p>
      {props.icon === "sending" ? (
        <CircularProgress
          size="17px"
          style={{ marginLeft: "5px", color: "#005651" }}
        />
      ) : (
        <span class="material-icons" style={{ ...props.iconStyles }}>
          {props.icon}
        </span>
      )}
    </div>
  );
}

export default ActionButton;
